import SectionHeading from '@/components/base/SectionHeading';

const TESTIMONIALS = [
  {
    quote:
      '以前刷热点要翻好几个平台，现在早上通勤十分钟看一遍今日速览就够了，要点写得很清楚，不用自己再从长文里挑重点。',
    name: '林一然',
    role: '产品运营 · 上海',
  },
  {
    quote:
      '最喜欢精简摘要那一段。有时候开会间隙只有两分钟，看摘要就能跟上同事聊的话题，也不会觉得自己在信息里掉队。',
    name: '周晓棠',
    role: '自由设计师 · 成都',
  },
  {
    quote:
      '他们不追着煽动情绪，只把进展和背景理清楚。作为内容从业者，我经常把这里的要点当成选题前的资料索引。',
    name: '陈叙',
    role: '内容编辑 · 广州',
  },
];

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="Readers"
          title="读者怎么说"
          desc="我们把读者的反馈当作内容标准的一部分，每一条都会记录进改版清单。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {TESTIMONIALS.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col justify-between rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-accent-500" aria-hidden="true"></i>
              <blockquote className="mt-4 flex-1 font-body text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-700">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block font-heading text-sm font-semibold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="mt-0.5 block font-body text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}